export default __webpack_public_path__ + "static/media/project-5.81db8d5f.jpg";